<template>
  <el-dialog
    class="upload-center"
    :title="importObj.title || '导入文件'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="dialogVisible"
    width="40%"
    @close="handleCancel"
  >
    <div v-loading="loading">
      <div class="download-template">
        <a class="btn-download" @click="handleDownloadTemplate">
          <el-button size="mini" type="primary" :disabled="processing" plain>
            <i class="e6-icon-download_line"></i>
            下载模板
          </el-button>
        </a>
      </div>
      <div class="import">
        <el-upload
          class="upload-demo"
          ref="upload"
          :file-list="fileList"
          :http-request="myUpload"
          action=""
          accept=".xls,.xlsx"
          :headers="importHeaders"
          :limit="1"
          :on-change="handleChange"
          :before-upload="beforeUpload"
          :on-remove="handleRemove"
          :auto-upload="false"
          :disabled="disabledUpload"
        >
          <el-button size="mini" type="primary" :disabled="disabledUpload">
            <i class="e6-icon-upload_line"></i>
            {{ uploadTip }}
          </el-button>
          <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
          <div
            slot="tip"
            v-if="disabledUpload"
            style="
              position: absolute;
              bottom: 3px;
              right: 0px;
              cursor: pointer;
              z-index: 100;
            "
            @click="handleRemove"
          >
            <i class="el-icon-close"></i>
          </div>
        </el-upload>
        <el-button
          class="import-btn"
          type="success"
          size="mini"
          @click="submitUpload"
          >点击导入</el-button
        >
      </div>
      <el-table
        v-if="tableData.length > 0"
        class="mt20"
        max-height="300px"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          label="序号"
          header-align="center"
          align="center"
          prop="modelName"
        ></el-table-column>
        <el-table-column
          label="失败原因"
          align="center"
          show-overflow-tooltip
          prop="msg"
        >
        </el-table-column>
      </el-table>
    </div>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel()">取消</el-button>
      <el-button type="primary" @click="submit()">保存</el-button>
    </div> -->
  </el-dialog>
</template>

<script type="text/babel">
// import { importFile } from "@/api/uploadCenter/index";
import axios from "axios";
export default {
  name: "uploadCenter",
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    initInfo: {
      type: Object,
      default: () => {
        return {
          title: "导入文件",
          templateUrl: "",
          importUrl: "",
        };
      },
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(v) {
        this.updatevisible(v);
      },
    },
  },
  data() {
    return {
      base: "",
      loading: false,
      importHeaders: {
        enctype: "multipart/form-data",
      },
      fileList: [],
      file: "",
      processing: false,
      disabledUpload: false,
      uploadTip: "点击上传",
      importObj: {},
      showTableInfo: false,
      tableData: [],
      colArr: [],
    };
  },
  mounted() {
    this.base =
      process.env.NODE_ENV == "production" ? window.location.origin : "";
    this.importObj.title = this.initInfo.title || "导入文件";
    this.importObj.templateUrl = this.initInfo.templateUrl || "";
    this.importObj.importUrl = this.initInfo.importUrl || "";
  },

  methods: {
    updatevisible(v) {
      this.$emit("update:visible", v);
      if (v == false) {
        this.disabledUpload = false;
      }
    },
    // 下载模板
    handleDownloadTemplate() {
      let downloadIframe = document.createElement("iframe");
      downloadIframe.setAttribute(
        "src",
        `${this.base}${this.importObj.templateUrl}` || ""
      );
      downloadIframe.setAttribute("style", "display: none");
      document.body.appendChild(downloadIframe);
    },
    //上传前配置
    beforeUpload(file) {
      let excelfileExtend = ".xls,.xlsx"; //设置文件格式
      let fileExtend = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();
      if (excelfileExtend.indexOf(fileExtend) <= -1) {
        this.$message.error("文件格式错误");
        return false;
      }
    },

    handleChange(file, fileList) {
      this.fileList = fileList;
      this.tableData = [];
      this.disabledUpload = true;
    },
    // 删除文件
    handleRemove() {
      this.fileList = [];
      this.file = "";
      this.tableData = [];
      this.disabledUpload = false;
    },
    submitUpload() {
      if (this.fileList.length > 0) {
        if (this.$route.path == "/vehiclePassCheckHistory") {
          this.openComfirm();
        } else {
          this.$refs.upload.submit();
        }
      } else {
        this.$message.warning("请选择文件上传！");
      }
    },
    openComfirm() {
      this.$confirm(
        "导入后，表格中车辆将被取消城市冷配资格，操作不可逆，请确认是否继续导入？",
        "导入确认",
        { type: "warning" }
      )
        .then(() => {
          this.$refs.upload.submit();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    myUpload(params) {
      this.file = params.file;
      this.getFileIde(); // 请求
    },
    async getFileIde() {
      let formData = new FormData();
      formData.append("uploadFile", this.file);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      // 发起请求
      axios
        .post(this.importObj.importUrl, formData, config)
        .then((res) => {
          let data = res.data;
          if (data.code) {
            this.$message.success("导入成功");
            this.updatevisible(false);
          } else {
            if (Array.isArray(data.result)) {
              this.tableData = data.result;
              this.$message.warning("导入失败");
            } else {
              this.$message.errpr(data.message);
            }
          }
        })
        .catch((error) => {
          this.$message.error("发生异常");
          console.log(error);
        });
    },
    handleCancel() {
      this.tableData = [];
      this.fileList = [];
      this.file = "";
      this.updatevisible(false);
    },
  },
};
</script>
<style lang="scss" scoped>
.mt20 {
  margin-top: 20px;
}
.upload-center {
  .upload-demo {
    margin-top: 15px;
  }
  .import {
    position: relative;
    .e6-icon-upload_line {
      font-size: 12px !important;
    }
    .import-btn {
      padding-top: 8px !important;
      position: absolute;
      top: 0;
      left: 110px;
      span {
        font-size: 13px;
      }
    }
  }
  /deep/ .el-upload-list__item {
    &:hover {
      background-color: transparent;
      .el-upload-list__item-status-label {
        display: none;
      }
    }
  }
}
/deep/ .el-dialog {
  .el-dialog__body {
    padding: 20px;
  }
  .el-button--default {
    background: #dae1eb;
    color: #909399;
  }
  .el-dialog__footer {
    text-align: center;
  }
}
.tip-msg {
  color: #67c23a;
  font-weight: 600;
}
.red-msg {
  color: #f56c6c !important;
}
</style>
